import styled from 'styled-components';

export const HeaderTitle = styled.div`
    font-size: 16px;
    margin: 10px 0;
    color: ${({ theme }) => theme.textColor};
`;
